import * as types from "../constants/ShootsActionTypes";
import _ from "lodash";
import update from "immutability-helper";

const initState = {
  startShoot: {
    fetching: false,
    updating: false,
    open: false
  },
  fetching: true,
  fetched: false,
  failed: false,
  updating: false,
  action: null,
  status: null,
  shots: {
    photo: {
      fetching: false,
      fetched: false,
      updating: false,
      selectedAll: false,
      data: []
    },
    video: {
      fetching: false,
      fetched: false,
      update: false,
      selectedAll: false,
      data: []
    }
  },
  packages: {
    photo: {
      fetching: false,
      fetched: false,
      updating: false,
      selectedAll: false,
      data: []
    },
    video: {
      fetching: false,
      fetched: false,
      update: false,
      selectedAll: false,
      data: []
    }
  },
  questions: {
    fetching: false,
    fetched: false,
    updating: false,
    selectedAll: false,
    selectedQuestions: [],
    data: [],
    positions: []
  }
};

const shootreducers = (state = initState, action = {}) => {
  switch (action.type) {
    case types.SHOOTS_START_DIALOG_OPEN:
      return _.assign({}, state, {
        startShoot: { ...state.startShoot, open: true }
      });
    case types.SHOOTS_START_DIALOG_CLOSE:
      return _.assign({}, state, {
        startShoot: { ...state.startShoot, open: false }
      });
    case types.SHOOTS_GET_ONE:
      return _.assign({}, state, {
        startShoot: {
          ...state.startShoot,
          fetching: true && state.startShoot.open
        },
        fetching: true && !state.startShoot.open
      });
    case types.SHOOTS_GET_ONE_SUCCESS: {
      let { shots, ...shootDetails } = action.shoot;
      let { photo, video } = state.shots;
      photo = _.assign({}, photo, {
        fetched: true,
        data: shots.photo
      });
      video = _.assign({}, video, {
        fetched: true,
        data: shots.video
      });
      return _.assign(
        {},
        state,
        {
          startShoot: {
            ...state.startShoot,
            fetching: false && state.startShoot.open
          },
          fetching: false,
          fetched: true
        },
        {
          shots: {
            photo,
            video
          },
          ...shootDetails
        }
      );
    }
    case types.SHOOTS_START:
      return _.assign({}, state, {
        startShoot: { ...state.startShoot, updating: true }
      });
    case types.SHOOTS_START_SUCCESS:
      return _.assign({}, state, {
        startShoot: {
          ...state.startShoot,
          updating: false,
          open: false
        }
      });
    case types.SHOOTS_GET_SHOTS: {
      let shots = state.shots;
      let shotType = _.assign({}, shots[action.shot_type], {
        ...shots[action.shot_type],
        fetching: true
      });
      let newShots = _.assign({}, shots, {
        [action.shot_type]: {
          ...shotType
        }
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_GET_SHOTS_SUCCESS: {
      let shots = state.shots;
      let shotType = _.assign({}, shots[action.shot_type], {
        ...shots[action.shot_type],
        fetching: false,
        fetched: true,
        data: action.shots
      });
      let newShots = _.assign({}, shots, {
        [action.shot_type]: {
          ...shotType
        }
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_HANDLE_CHECKBOX: {
      let { shot_type, index } = action;
      let shots = state.shots;
      let shotTypeShots = shots[shot_type].data[index];
      let shot = _.assign({}, { ...shotTypeShots }, { selected: !shotTypeShots.selected });
      let data = _.assign([], shots[shot_type].data, { [index]: shot });
      let selectedAll = true;
      for (let i = 0; i < data.length; i++) {
        if (!data[i].selected) {
          console.log(data[i]);
          selectedAll = false;
          break;
        }
      }
      let shotType = _.assign({}, shots[shot_type], {
        ...shots[shot_type],
        data,
        selectedAll
      });
      let newShots = _.assign({}, shots, {
        [shot_type]: {
          ...shotType
        }
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_HANDLE_CHECKBOX_ALL: {
      let { shot_type } = action;
      let selectedAllStatus = state.shots[shot_type].selectedAll;
      let shots = state.shots;
      let shotData;
      if (!selectedAllStatus) {
        shotData = _.map(state.shots[shot_type].data, (shot, index) => {
          shot.selected = true;
          return shot;
        });
      } else {
        shotData = _.map(state.shots[shot_type].data, (shot, index) => {
          shot.selected = false;
          return shot;
        });
      }
      let shotType = _.assign({}, shots[shot_type], { data: shotData }, { selectedAll: !selectedAllStatus });
      let newShots = _.assign({}, shots, {
        [shot_type]: {
          ...shotType
        }
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_REMOVE_SHOTS: {
      let { shot_type } = action;
      let { shots } = state;
      let shotType = shots[shot_type];
      let newShotType = _.assign({}, shotType, { fetching: true });
      let newShots = _.assign({}, shots, {
        [shot_type]: newShotType
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_REMOVE_SHOTS_SUCCESS: {
      let { shot_type } = action;
      let { shots } = state;
      let shotType = shots[shot_type];
      let newShotType = _.assign({}, shotType, { fetching: true });
      let newShots = _.assign({}, shots, {
        [shot_type]: newShotType
      });
      return _.assign({}, state, {
        shots: newShots
      });
    }
    case types.SHOOTS_CHECK_APPROVE:
      return update(state, {
        shots: {
          [action.shot_type]: {
            fetching: { $set: true }
          }
        }
      });
    case types.SHOOTS_CHECK_APPROVE_SUCCESS:
      return update(state, {
        shots: {
          [action.shot_type]: {
            selectedAll: { $set: false }
          }
        }
      });
    case types.SHOOTS_CHECK_REJECT:
      return update(state, {
        shots: {
          [action.shot_type]: {
            fetching: { $set: true }
          }
        }
      });
    case types.SHOOTS_CHECK_REJECT_SUCCESS:
      return update(state, {
        shots: {
          [action.shot_type]: {
            selectedAll: { $set: false }
          }
        }
      });
    case types.SHOOTS_MARK_SHOOT_COMPLETE:
      return update(state, {
        fetching: { $set: true }
      });
    case types.SHOOT_GET_STATUS_SUCCESS:
      return _.assign({}, state, { status: action.status });
    case types.SHOOT_UPDATE_SHOT_PRIORITY:
      return update(state, {
        shots: {
          [action.shot_type]: {
            fetching: { $set: true }
          }
        }
      });
    case types.SHOOT_GET_QUESTION:
      return update(state, {
        questions: {
          fetching: { $set: true }
        }
      });
    case types.SHOOT_GET_QUESTION_SUCCESS:
      return update(state, {
        questions: {
          fetching: { $set: false },
          fetched: { $set: true },
          updating: { $set: false },
          data: { $set: action.data },
          positions: { $set: action.positions }
        }
      });
    case types.SHOOT_QUESTION_SET_SELECTEDQUESTIONS:
      return update(state, {
        questions: {
          selectedQuestions: { $set: action.selectedQuestions }
        }
      });
    case types.SHOOT_QUESTION_RESET_SELECTEDQUESTIONS:
      return update(state, {
        questions: {
          selectedQuestions: { $set: [] }
        }
      });
    case types.SHOOT_QUESTION_REMOVE:
      return update(state, {
        questions: {
          fetching: { $set: true }
          // fetched: { $set: true },
          // updating: { $set: true },
        }
      });
    case types.SHOOT_QUESTION_REMOVE_SUCCESS:
      return update(state, {
        questions: {
          fetching: { $set: false },
          selectedQuestions: { $set: [] }
        }
      });
    case types.SHOOT_GET_PACKAGES:
      return update(state, {
        packages: {
          [action.shot_type]: {
            fetching: { $set: true }
          }
        }
      })
    case types.SHOOT_GET_PACKAGES_SUCCESS:
      return update(state, {
        packages: {
          [action.shot_type]: {
            fetching: { $set: false },
            fetched: { $set: true },
            data: { $set: action.data }
          }
        }
      })
    default:
      return state;
  }
};

export default shootreducers;
